
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDButton from "components/MDButton";
import ButtonGroup from "@mui/material/ButtonGroup";
import CustomAlert from "components/CustomAlert";
import MDInput from "components/MDInput";
import DinamicDate from "components/DinamicDateFields";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from "@mui/material/Backdrop";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Typography } from '@mui/material';
import { Alert } from "@mui/material";
import axios from 'axios';


// Data
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
// import { useMaterialUIController, setLoading } from "context";
import {
  useMaterialUIController,
  setLoading as setGlobalLoading
} from "context";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup'
import { ImportAPI } from "api/ImportAPI";
import dayjs from 'dayjs';
import DataTable from "examples/Tables/DataTable";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// 1. Agrega el helper de delay aquí arriba
const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default function Import() {
  const [controller, dispatch] = useMaterialUIController();
const { loading } = controller;

  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const [warning, setWarning] = useState('');
  const [title, setTitle] = useState('');
  const [apiName, setApiName] = useState('');
  const [apiNameURL, setApiNameURL] = useState('');
  const navigate = useNavigate();
  const FILE_SIZE = 30000000000;
  const location = useLocation();
  
  const [token, setToken] = useState('');
  const [message, setMessage] = useState('');
  const [pathResource, setPathResource] = useState('');
  const hideImportButton = location.pathname === '/product-arrays/material-master-exclusive-import';

  const [importId, setImportId] = useState(null);
  const [importState, setImportState] = useState(null);
  const [pollingImport, setPollingImport] = useState(false);

  /** ************************************************** **/
  
  // VARIABLES DE ENTORNO PARA CREDENCIALES API YEMINUS

  // const BASE_URL = "http://localhost:8000/api/proxy";
  const BASE_URL = process.env.REACT_APP_API_YEMINUS;
  const USER_ID = process.env.REACT_APP_USER_YEMINUS;
  const COMPANY_ID = process.env.REACT_APP_COMPANY_YEMINUS;
  const USER_PASSWORD = process.env.REACT_APP_PASS_YEMINUS;

  /** ************************************************** **/
  
  const [formData, setFormData] = useState({});
  const [fields, setFields] = useState([]);
  const [body, setBody] = useState([]);
  const [advertencias, setAdvertencias] = useState([]);
  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const [dataImport, setDataImport] = useState({});
  const [open, setOpen] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingYeminus, setLoadingYeminus] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // useEffect(() => {
  //   const authenticate = async () => {
    
  //     try {
  //       const response = await axios.post(`${BASE_URL}/token`, {
  //         userName: USER_ID,
  //         password: USER_PASSWORD,  
  //         grant_type: 'password',  
  //       }, {
  //         headers: {
  //           'Content-Type': 'application/x-www-form-urlencoded',  
  //         },
  //       });
    
  //       const token = response.data.access_token;  
  //       setToken(token);
  //     } catch (error) {
  //       console.error('Error during authentication:', error);
  //     }
  //   };

  //   authenticate();

  // }, []);

  useEffect(() => {

    const authenticate = async () => {
      setLoadingYeminus(true);

      try {

        const response = await axios.post(
          `${BASE_URL}/token`
        );

        const token = response.data.access_token;
        setToken(token);

      } catch (error) {

        console.error(
          'Error durante la autenticación con Yéminus:',
          error
        );

        if (
          error.response?.status === 503 &&
          error.response?.data?.type === 'connection_error'
        ) {
          handleAlert(
            error.response.data.message,
            "error"
          );
          setMessage(error.response.data.message);
          return;
        }

        handleAlert(
            error.response.data.message,
            "error"
          );
        setMessage(
          error.response?.data?.message ||
          'No fue posible realizar la autenticación con Yéminus.'
        );
      } finally {
        setLoadingYeminus(false);
      }

    };

    authenticate();

  }, []);

  useEffect(() => {
    if (location.pathname === '/product-arrays/consumption-history-import') {
      setTitle('Importar Historial de Consumo')
      setWarning('|   producto   |   descripcion   |   cantidad   |   fecha   |   unitario   |   valor_total   |')
    } else if (location.pathname === '/product-arrays/balance-master-import') {
      setTitle('Importar Maestro de Saldos')
      setWarning('|   codigo_producto   |   cantidad   |   costo_unitario   |')
    }
    else if (location.pathname === '/product-arrays/ep-master-import') {
      setTitle('Importar Maestro EP')
      setWarning('|   codigo_pt   |   codigo_mp   |   cantidad   |   codigo_pp   |   cantidad_pp   |   descripcion   |   proceso   |   nombre_proceso   |   linea   |   nombre_linea   |   estado   |')
    }
    else if (location.pathname === '/product-arrays/finished-product-master-import') {
      setTitle('Importar Maestro Producto Terminado')
      setWarning('|   codigo |   nombre_linea   |   linea   |')
    }
    else if (location.pathname === '/product-arrays/material-master-import') {
      setTitle('Importar Maestro de Materiales')
      setWarning('|   producto   |   descripcion   |   tipo   |   grupo   |   origen   |   lt   |   ls   |')
    }
    else if (location.pathname === '/product-arrays/oc-master-import') {
      setTitle('Importar Maestro OC')
      setWarning('|   cod_producto   |   pendiente   |   vr_unitario   |')
    }
    else if (location.pathname === '/product-arrays/order-master-import') {
      setTitle('Importar Maestro de Pedidos')
      setWarning('|   cod_producto   |   pendiente   |   vr_unitario   |')
    }
    // else if (location.pathname === '/product-arrays/unit-value-import') {
    //   setTitle('Importar Valor Unitario')
    //   setWarning('|   codigo   |   vr_u_promedio')
    // }
    else if (location.pathname === '/product-arrays/consumption-history-finished-product-import') {
      setTitle('Importar Historial de Consumo Producto Terminado')
      setWarning('|   producto   |   descripcion   |   cantidad   |   fecha   |   vr_unitario   |   valor_total   |')
    }
    else if (location.pathname === '/product-arrays/op-master-import') {
      setTitle('Importar Maestro OP')
      setWarning('|   cod_producto   |   pendiente   |   vr_unitario   |')
    }
    else if (location.pathname === '/product-arrays/material-master-exclusive-import') {
      setTitle('Importar Maestro de Materiales Exclusivos')
      setWarning('|   codigo   |   tipo   |')
    }
    else if (location.pathname === '/product-arrays/vn-pt-uh-import') {
      setTitle('Importar Valores Nominales')
      setWarning('|   producto   |   descripcion   |   tipo   |   linea   |   corte   |   aplicacion   |   adicionales   |   conexion   |   manguera   |   union   |')
    }
    const pathParts = location.pathname.split('/');
    const lastPart = pathParts[pathParts.length - 1];
    setApiName(lastPart);
    setApiNameURL(lastPart);
    getPostBody(lastPart);
    
  }, []);

  const SUPPORTED_EXCEL_TYPES = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/csv",
  ];

  const formSchema = yup.object().shape({
    file: yup.mixed().test('required', 'Por favor selecciona un archivo', (value) => value && value.length)
      .test('fileSize', 'Archivo demasiado grande', (value) => value[0] && value[0].size <= FILE_SIZE)
      .test('fileType', 'Solo se aceptan archivos de excel', (value) => value[0] && SUPPORTED_EXCEL_TYPES.includes(value[0].type))
  })

  const { handleSubmit, formState: { errors, isSubmitting }, register } = useForm({ resolver: yupResolver(formSchema), });

  const handleAlert = (content, color) => {
    setAlertContent(content);
    setAlertColor(color);
    setAlert(true)
  }

  const handleAlertClose = () => setAlert(false);

  useEffect(() => {
    if ( window.location.pathname == '/product-arrays/material-master-exclusive-import' )
      setGlobalLoading(dispatch, false);
    else
      setGlobalLoading(dispatch, true);

    const fetchPostBody = async () => {
      const { body, fields } = await getPostBody();
      setFields(fields); 

      const initialFormData = {};
      fields.forEach((field) => {
        initialFormData[field.codigo] = field.valor || ''; 
      });

      // setFormData(initialFormData);
      setFormData((prev) => {
        if (Object.keys(prev).length > 0) return prev;
        return initialFormData;
      });
      setBody(body); 
      
    };
  
    fetchPostBody();
    
  }, [apiName]);

  useEffect(() => {
    if (fields.length > 0) {
      setGlobalLoading(dispatch, false);  
    }
  }, [fields]);

  useEffect(() => {
    if (!pollingImport || !importId) return;

    const interval = setInterval(async () => {
      try {
        const response = await ImportAPI.getImportStatus(importId);

        const state = response.data.state;

        setImportState(state);

        if (state === "completed") {
          clearInterval(interval);
          setPollingImport(false);

          handleAlert(
            "Importación finalizada correctamente",
            "success"
          );
        }

        if (state === "failed") {
          clearInterval(interval);
          setPollingImport(false);

          handleAlert(
            response.data.data.error_message || "La importación falló",
            "error"
          );
        }

      } catch (error) {
        console.error("Error polling import:", error);
        console.error("Response polling:", error.response);

        clearInterval(interval);
        setPollingImport(false);

        handleAlert(
          "No se pudo consultar el estado de la importación",
          "error"
        );
      }
    }, 4000);

    return () => clearInterval(interval);

  }, [pollingImport, importId]);
   
   const getPostBody = async (path) => {
    // const hoy           = dayjs().format("DD-MM-YYYY");
    // const haceTresMeses = dayjs().subtract(12, "month").format("DD-MM-YYYY");
    // const haceCuatroMeses      = dayjs().subtract(4, "month").format("DD-MM-YYYY");

    const hoy             = dayjs().format("YYYY-MM-DD");
    const haceTresMeses   = dayjs().subtract(12, "month").format("YYYY-MM-DD");
    const haceCuatroMeses = dayjs().subtract(4, "month").format("YYYY-MM-DD");
    
    let fields          = [];
    let body            = {};

    switch (apiName) {
      case 'balance-master-import':
        //EXISTENCIAS-BODEGA-COSTO
        fields = [
          { label: 'Año', codigo: 'AÑO', tipo: 'select', options: ['2000','2001','2002','2003','2004','2005','2006','2007','2008','2009','2010','2011','2012','2013','2014','2015','2016','2017','2018', '2019', '2020','2021','2022', '2023', '2024', '2025', '2026'] },
          { label: 'Mes', codigo: 'MES', tipo: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] }
        ];
       body = {
        idInforme: 5,
        crearArchivo: false,
        variablesFiltro: [
          { codigo: 'AÑO', valor: '2023' },
          { codigo: 'MES', valor: '1' }
        ],
        filtroVariableInforme: []
      };
      break;

      case 'material-master-importgg':
        //Consulta de existencia resumidas por familia
        fields = [
          { label: 'Fecha Inicio', codigo: 'fecha_ini_dd-mm-yyyy', tipo: 'date' },
          { label: 'Fecha Fin', codigo: 'fecha_fin_dd-mm-yyyy', tipo: 'date' }
        ];
        return {
          idInforme: 12,
          crearArchivo: false,
          variablesFiltro: [
            { codigo: 'anio', valor: '2024' },
            { codigo: 'mes', valor: '1' }
          ],
          filtroVariableInforme: []
        };
      case 'material-master-import':
        //Consultas de existencias a la fecha
        fields = [
          { label: 'Año', codigo: 'anio', tipo: 'select', options: ['2000','2001','2002','2003','2004','2005','2006','2007','2008','2009','2010','2011','2012','2013','2014','2015','2016','2017','2018', '2019', '2020','2021','2022', '2023', '2024', '2025', '2026'] },
          { label: 'Mes', codigo: 'mes', tipo: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] }
        ];

        body = {
          idInforme: 12,
          crearArchivo: false,
          variablesFiltro: [
            { codigo: 'anio', valor: '2024' },
            { codigo: 'mes', valor: '1' }
          ],
          filtroVariableInforme: []
        };
        break;

      case 'ep-master-import':
        //Resumen de consumos mes a mes
        fields = [
          { label: 'Año', codigo: 'anio', tipo: 'select', options: ['2000','2001','2002','2003','2004','2005','2006','2007','2008','2009','2010','2011','2012','2013','2014','2015','2016','2017','2018', '2019', '2020','2021','2022', '2023', '2024', '2025', '2026'] },
          { label: 'Mes', codigo: 'mes', tipo: 'select', options: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] }
        ];

        body = {
          idInforme: 12,
          crearArchivo: false,
          variablesFiltro: [
            { codigo: 'anio', valor: '2024' },
            { codigo: 'mes', valor: '1' }
          ],
          filtroVariableInforme: []
        };
        break;
      case 'material-master-import231':
        //Ingresos mp nacional e importada
        return {
          idInforme: 16,
          crearArchivo: false,
          variablesFiltro: [
            { codigo: 'fecha_ini_dd-mm-yyyy', valor: '01/08/2023' },
            { codigo: 'fecha_ini_dd-mm-yyyy', valor: '01/08/2023' }
          ],
          filtroVariableInforme: []
        };
        case 'order-master-import':
          //compras por proveedor

          fields = [
            { label: 'Fecha Inicio', codigo: 'DESDE_DD/MM/YYYY', tipo: 'date', valor: haceCuatroMeses },
            { label: 'Fecha Fin', codigo: 'HASTA_DD/MM/YYYY', tipo: 'date', valor: hoy }
          ];
          body = {
            idInforme: 6,
            crearArchivo: false,
            variablesFiltro: [
              { label: 'Fecha Inicio', codigo: 'DESDE_DD/MM/YYYY', tipo: 'date', valor: '' },
              { label: 'Fecha Fin', codigo: 'HASTA_DD/MM/YYYY', tipo: 'date', valor: '' }
          ],
          filtroVariableInforme: []
        };
        break;

      case 'material-master-import324333':
        //Facturacion por unidad de negocio
        return {
          idInforme: 22,
          crearArchivo: false,
          variablesFiltro: [
            { codigo: 'grupo', valor: 'A1' },
            { codigo: 'origen', valor: 'Nacional' }
          ],
          filtroVariableInforme: []
        };
      case 'oc-master-import':
        //Pedidos de cliente clientes
        fields = [
          { label: 'Fecha Inicio', codigo: 'DESDE_DD/MM/YYYY', tipo: 'date', valor: haceTresMeses},
          { label: 'Fecha Fin', codigo: 'HASTA_DD/MM/YYYY', tipo: 'date', valor: hoy }
        ];
        body = {
          idInforme: 7,
          crearArchivo: false,
          variablesFiltro: [
            { codigo: 'echa_ini_dd-mm-yyyy', valor: '01-01-2023' },
            { codigo: 'echa_ini_dd-mm-yyyy', valor: '01-01-2024' }
          ],
          filtroVariableInforme: []
        };
        break;

      case 'consumption-history-import':
        //Informe de facturacion diaria
        const fechaIniEspecifica = await obtenerFechaEspecificaDesdeBD();

        fields = [
          { label: 'Fecha Inicio', codigo: 'DESDE_DD/MM/YYYY', tipo: 'date', valor: fechaIniEspecifica},
          { label: 'Fecha Fin', codigo: 'HASTA_DD/MM/YYYY', tipo: 'date', valor: '' }
        ];
        
          body = {
          idInforme: 8,
          crearArchivo: false,
          variablesFiltro: [
            { codigo: "DESDE_DD/MM/YYYY", valor: fechaIniEspecifica },
            { codigo: "HASTA_DD/MM/YYYY", valor: "30-01-2023" }
          ],
          filtroVariableInforme: []
          };
          break;

      case 'material-master-exclusive-import':
        fields = [];

        body = {
          idInforme: 42,
          crearArchivo: false
        };
        break;
        
    }

    return { body, fields };

  };

  const obtenerFechaEspecificaDesdeBD = async () => {
    try {
      const response = await ImportAPI.import(null, 'get-last-historyImport-date');
  
      if (response?.date) {
        return response.date;
      } else {
        console.error('Error al obtener la fecha:', response.message || 'Fecha no encontrada');
        return '01-01-2023'; 
      }
    } catch (error) {
      console.error('Error al obtener la fecha:', error);
      return '01-01-2023';
    }
  };


  const formatearFecha = (fecha) => {
    const [year, month, day] = fecha.split('-');
    return `${day}-${month}-${year}`;
  };

//funcion para armar el body 
//const { fields } = getPostBody(apiName) || { fields: [] };
//capturar los fields del body

  //accion para importar manejo de

  const formatDateIfNeeded = (dateString) => {
    if (!dateString) return '';
    const regexYYYYMMDD = /^\d{4}-\d{2}-\d{2}$/;
    if (regexYYYYMMDD.test(dateString)) {
      const [year, month, day] = dateString.split('-');
      return `${day}-${month}-${year}`; 
    }
    return dateString; 
  };

  const downloadExcel = () => {
    if (!dataImport || dataImport.length === 0) {
      handleAlert("No hay datos para exportar", "warning");
      return;
    }

    // Crear la hoja desde todos los datos reales
    const worksheet = XLSX.utils.json_to_sheet(dataImport);

    // Crear libro
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");

    // Convertir a binario
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Descargar
    saveAs(
      new Blob([excelBuffer], { type: "application/octet-stream" }),
      `${apiName}-export.xlsx`
    );
  };

  const toApiDate = (dateString) => {
    if (!dateString) return '';

    const parsed = dayjs(dateString, "YYYY-MM-DD", true);

    return parsed.isValid()
      ? parsed.format("DD-MM-YYYY")
      : dateString;
  };

  const onSubmitImport = async () => {

    let valid = true;
    let missingFields = [];

    // Validar los campos requeridos
    fields.forEach((field) => {
      let fieldValue = formData[field.codigo] !== undefined ? formData[field.codigo] : ''; 

      fieldValue = formatDateIfNeeded(fieldValue);

      formData[field.codigo] = fieldValue;
      
      if (field.tipo === 'date' && (!fieldValue || fieldValue === '')) {
        valid = false;
        missingFields.push(field.label);
      } 
      else if (field.tipo === 'select' && (!fieldValue || fieldValue === 'none')) {
        valid = false;
        missingFields.push(field.label);
      }  else if (!fieldValue) {
        valid = false;
        missingFields.push(field.label);
      }

    }); 

    
    if (!valid) {
      handleAlert(`Debe diligenciar los siguientes campos: ${missingFields.join(', ')}`, 'error')
      setMessage(`Faltan los siguientes campos: ${missingFields.join(', ')}`);
      return;
    }
    
    //const { body, fields } = getPostBody();
  
    // const variablesFiltro = fields.map((field) => ({
    //   codigo: field.codigo,
    //   valor: formData[field.codigo] || '' 
    // }));

    const variablesFiltro = fields.map((field) => ({
      codigo: field.codigo,
      valor: field.tipo === 'date'
        ? toApiDate(formData[field.codigo] || '')
        : (formData[field.codigo] || '')
    }));

    const finalBody = {
      ...body,
      ...(variablesFiltro.length > 0 && {
        variablesFiltro
      })
    };

    let currentToken = token;
    if (!currentToken) {
      currentToken = await authenticate();
    }

    if (!currentToken) {
      setMessage('No se pudo obtener el token. Intenta nuevamente.');
      return;
    }
    
    const headers = {
      'Authorization': `Bearer ${currentToken}`, 
      'id_empresa': COMPANY_ID,
      'usuario': USER_ID,
      'Content-Type': 'application/json',
    };
    //const body = JSON.stringify(getPostBody());
    const finalBodyJson = JSON.stringify(finalBody); 

    try {
      setGlobalLoading(dispatch, true);
      const fullUrl = `${BASE_URL}/app/informes/informespersonalizados/ejecutarconsultainforme`;

      if (apiName === 'oc-master-import') {
        const nuevasAdvertencias = []; // Variable local para recopilar
        setAdvertencias([]); // Limpiamos advertencias previas

        // 1. Extraer fechas del filtro
        const fechaInicialObj = variablesFiltro.find((v) => v.codigo === 'DESDE_DD/MM/YYYY');
        const fechaFinalObj   = variablesFiltro.find((v) => v.codigo === 'HASTA_DD/MM/YYYY');
        const fechaInicial    = fechaInicialObj ? fechaInicialObj.valor : '2026-07-01';
        const fechaFinal      = fechaFinalObj   ? fechaFinalObj.valor : '2026-08-30';

        const buildBodyEstados = (tipoDoc) => ({
          filtroDocumento: {
            filtrar: true,
            fechaInicialCausacion: fechaInicial,
            fechaFinalCausacion: fechaFinal,
            tiposDocumentos: [tipoDoc],
            vista: 1
          },
          filtroTrazabilidad: {
            mostrarDocsDestino1: true
          },
          numeroCaja: "1"
        });

        // ==========================================
        // PETICIÓN 1: Consultar OC
        // ==========================================
        let resOc = null;
        try {
          resOc = await axios.post(fullUrl, JSON.stringify(finalBody), { headers });
        } catch (errOc) {
          console.error("Error en Petición 1 (OC):", errOc);
          setMessage('Error al consultar las Órdenes de Compra en Yéminus.');
          setGlobalLoading(dispatch, false);
          return;
        }

        const isOcExitosa = resOc?.data?.infoOperacion?.esExitosa === true && Array.isArray(resOc?.data?.datos);
        if (!isOcExitosa) {
          const errorMsg = resOc?.data?.infoOperacion?.excepcion?.detalleErrorFiltrado 
            || resOc?.data?.infoOperacion?.excepcion?.Mensaje 
            || 'Error de servicio en Yéminus al consultar OC';
          setMessage(`No se pudieron obtener las Órdenes de Compra: ${errorMsg}`);
          setGlobalLoading(dispatch, false);
          return;
        }

        const datosOc = resOc.data.datos || [];
        await delay(1000);

        // ==========================================
        // PETICIÓN 2: Proveedores (Email)
        // ==========================================
        let datosContactos = [];
        let exitoPeticion2 = false;

        const finalBodyContactos = {
          idInforme: 44,
          crearArchivo: false,
          variablesFiltro: variablesFiltro
        };

        try {
          const resContactos = await axios.post(fullUrl, JSON.stringify(finalBodyContactos), { headers });
          
          if (resContactos?.data?.infoOperacion?.esExitosa === true && Array.isArray(resContactos?.data?.datos)) {
            datosContactos = resContactos.data.datos;
            exitoPeticion2 = true;
          } else {
            const errorProv = resContactos?.data?.infoOperacion?.excepcion?.detalleErrorFiltrado 
              || resContactos?.data?.datos 
              || 'Error en servidor de datos de proveedores';
            nuevasAdvertencias.push(`Fallo en petición de datos de proveedores (${errorProv}). Se omitió la consulta de estados de OC.`);
          }
        } catch (errProv) {
          console.error("Error en Petición 2 (Proveedores):", errProv);
          nuevasAdvertencias.push("Error de conexión al consultar datos de proveedores. Se omitió la consulta de estados de OC.");
        }

        // ==========================================
        // PETICIÓN 3: Estados OC (Sólo si Petición 2 fue Exitosa)
        // ==========================================
        let datosEstados = [];

        if (exitoPeticion2) {
          await delay(1000);
          const urlEstados = `${BASE_URL}/api/inventarios/documentos/obtenercabeceradocumento`;

          try {
            const resEstadosNacionales = await axios.post(urlEstados, buildBodyEstados("OC"), { headers });
            const docsNacionales = (resEstadosNacionales?.data?.infoOperacion?.esExitosa !== false && resEstadosNacionales?.data?.datos?.documentos) 
              ? resEstadosNacionales.data.datos.documentos 
              : [];

            await delay(1000);

            const resEstadosImportadas = await axios.post(urlEstados, buildBodyEstados("IMP"), { headers });
            const docsImportadas = (resEstadosImportadas?.data?.infoOperacion?.esExitosa !== false && resEstadosImportadas?.data?.datos?.documentos) 
              ? resEstadosImportadas.data.datos.documentos 
              : [];

            datosEstados = [...docsNacionales, ...docsImportadas];

            if (resEstadosNacionales?.data?.infoOperacion?.esExitosa === false || resEstadosImportadas?.data?.infoOperacion?.esExitosa === false) {
              nuevasAdvertencias.push("Ocurrió un error al consultar algunos estados de OC en Yéminus.");
            }
          } catch (errEstados) {
            console.error("Error en Petición 3 (Estados):", errEstados);
            nuevasAdvertencias.push("Error de conexión al consultar el estado de entregas.");
          }
        }

        // Actualizamos el estado de React con las advertencias encontradas
        setAdvertencias(nuevasAdvertencias);

        // ==========================================
        // MAPEO DE DATOS
        // ==========================================
        const estadosMap = new Map();
        datosEstados.forEach((est) => {
          const idOrden = String(est.referencia || est.numero || '').trim();
          let estadoCalculado = 'Pendiente';
          const { destino1, cantidadPendiente, cantidad } = est;

          const cantPend  = Number(cantidadPendiente || 0);
          const cantTotal = Number(cantidad || 0);

          if (destino1 !== null && cantPend === 0) {
            estadoCalculado = 'Entregada';
          } else if (destino1 === null && cantPend === cantTotal) {
            estadoCalculado = 'Pendiente';
          } else if (destino1 !== null && cantPend > 0 && cantPend < cantTotal) {
            estadoCalculado = 'Entrega parcial';
          }

          if (idOrden) {
            estadosMap.set(idOrden, estadoCalculado);
          }
        });

        const proveedoresMap = new Map();
        datosContactos.forEach((proveedor) => {
          if (proveedor.nitproveedor) {
            proveedoresMap.set(String(proveedor.nitproveedor).trim(), {
              email: proveedor.email || '',
              telefono: proveedor.telefono || '',
              celular: proveedor.celular || ''
            });
          }
        });

        const datosEnriquecidos = datosOc.map((orden) => {
          const codProveedor   = String(orden.codigO_PROVEEDOR || '').trim();
          const numOrden       = String(orden.numerO_DOC || orden.referencia || '').trim();
          const infoProveedor  = proveedoresMap.get(codProveedor);
          const estadoFollowUp = estadosMap.get(numOrden) || 'Pendiente';

          return {
            ...orden,
            email: infoProveedor ? infoProveedor.email : '',
            estado_follow_up: estadoFollowUp
          };
        });

        setDataImport(datosEnriquecidos);

        // ==========================================
        // POBLAR TABLA
        // ==========================================
        const columns = [
          { Header: 'Producto', accessor: 'coD_PRODUCTO' },
          { Header: 'Descripción', accessor: 'nombrE_PRODUCTO' },
          { Header: 'Cod. Proveedor', accessor: 'codigO_PROVEEDOR' },
          { Header: 'Cantidad', accessor: 'cantidad' },
          { Header: 'Costo Unitario', accessor: 'vR_UNITARIO' },
          { Header: 'Email Proveedor', accessor: 'email' },
          // { Header: 'Estado Follow Up', accessor: 'estado_follow_up' }
        ];

        const rows = datosEnriquecidos.slice(0, 20).map((item) => ({
          coD_PRODUCTO: item.coD_PRODUCTO,
          nombrE_PRODUCTO: item.nombrE_PRODUCTO,
          codigO_PROVEEDOR: item.codigO_PROVEEDOR,
          cantidad: item.pendiente,
          vR_UNITARIO: item.vR_UNITARIO,
          email: item.email,
          // estado_follow_up: item.estado_follow_up
        }));

        setTableData({ columns, rows });

        // ==========================================
        // MENSAJE FINAL
        // ==========================================
        if (nuevasAdvertencias.length > 0) {
          setMessage(`Órdenes de Compra cargadas con advertencias:\n- ${nuevasAdvertencias.join('\n- ')}`);
        } else {
          setMessage('Importación realizada con éxito');
        }
      } else {
        const response = await axios.post(fullUrl, finalBodyJson, { headers });
        
        if (response.data.infoOperacion.esExitosa) {
          setMessage('Importación realizada con éxito');
          const datos = response.data.datos;
          
          setDataImport(datos);
          
          let columns = [];
          if (apiName === 'balance-master-import') {

            columns = [
              { Header: 'Código Producto', accessor: 'codigO_PRODUCTO' },
              { Header: 'Cantidad', accessor: 'cantidad' },
              { Header: 'Costo Unitario', accessor: 'costO_UNITARIO' },
              { Header: 'Código Proveedor', accessor: 'referencia' },
              { Header: 'Costo total', accessor: 'costO_TOTAL' },
              { Header: 'Bodega', accessor: 'coD_BODEGA' }
            ];
          } else if (apiName === 'consumption-history-import') {
            columns = [
              { Header: 'Producto', accessor: 'codigoproducto' },
              { Header: 'Descripción', accessor: 'descripcion' },
              { Header: 'Cantidad', accessor: 'cantidad' },
              { Header: 'Fecha', accessor: 'fechadocumento' },
              { Header: 'Unitario', accessor: 'costounitario' },
              { Header: 'Valor Total', accessor: 'costototal' },
            ];
          }else if (apiName === 'order-master-import') {
            columns = [
              { Header: 'Producto', accessor: 'producto' },
              { Header: 'Pendiente', accessor: 'pendiente' },
              { Header: 'Unitario', accessor: 'valoR_UNITARIO' },
              
            ];
          }else if (apiName === 'material-master-import') {
            columns = [
              { Header: 'Código Producto', accessor: 'codigo' },
              { Header: 'Descripción', accessor: 'descripcionproducto' },
              { Header: 'Cantidad', accessor: 'cantidad' },
              { Header: 'Costo Unitario', accessor: 'costounitario' },
              { Header: 'LS', accessor: 'ls' },
              { Header: 'LT', accessor: 'lt' },
              { Header: 'Origen', accessor: 'origen' },
          
            ];
          }
          // else if (apiName === 'oc-master-import') {
            // columns = [
            //   { Header: 'Producto', accessor: 'coD_PRODUCTO' },
            //   { Header: 'Descripción', accessor: 'nombrE_PRODUCTO' },
            //   { Header: 'Grupo', accessor: 'nombrE_GRUPO' },
            //   { Header: 'Cantidad', accessor: 'cantidad' },
            //   { Header: 'Costo Unitario', accessor: 'vR_UNITARIO' },
          
            // ];
          // }
          else if (apiName === 'ep-master-import') {
            columns = [
              { Header: 'Producto', accessor: 'coD_PRODUCTO' },
              { Header: 'Descripción', accessor: 'nombrE_PRODUCTO' },
              { Header: 'Grupo', accessor: 'nombrE_GRUPO' },
              { Header: 'Cantidad', accessor: 'cantidad' },
              { Header: 'Costo Unitario', accessor: 'vR_UNITARIO' },
              { Header: 'Nombre proceso', accessor: 'nombre_proceso' },
              { Header: 'Proceso', accessor: 'proceso' },
              { Header: 'Linea', accessor: 'linea' },
              { Header: 'Estado', accessor: 'estado' },
          
            ];
          } else if (apiName === 'material-master-exclusive-import') {
            columns = [
              { Header: 'Producto', accessor: 'producto' },
              { Header: 'Exclusivo', accessor: 'exclusivo' },
            ];
          }
    
          try {

            let filteredDatos = datos;

            if (apiName === 'balance-master-import') {
              filteredDatos = datos.filter(
                (item) => !['02', '04', '07'].includes(String(item.coD_BODEGA).trim())
              );
            }

            const rows = (
              apiName === 'material-master-exclusive-import'
                ? datos.filter(
                    item =>
                      item.exclusivo !== null &&
                      item.exclusivo !== undefined &&
                      item.exclusivo !== ''
                  )
                : datos
            ).slice(0, 20).map((item) => {
              if (apiName === 'balance-master-import') {
                return {
                  codigO_PRODUCTO: item.codigO_PRODUCTO,
                  cantidad: item.cantidad,
                  costO_UNITARIO: item.costO_UNITARIO,
                  codigo_proveedor: item.referencia,
                  costO_TOTAL: item.costO_TOTAL,
                  coD_BODEGA: item.coD_BODEGA
                };
              } else if (apiName === 'consumption-history-import') {
                return {
                  codigoproducto: item.codigoproducto,
                  descripcion: item.descripcionproducto,
                  cantidad: item.cantidad,
                  fechadocumento: item.fechadocumento,
                  costounitario: item.costounitario,
                  costototal: item.costototal,
                };
              }else if (apiName === 'order-master-import') {
                return {
                  producto: item.coD_PRODUCTO,
                  pendiente: item.pendiente,
                  valoR_UNITARIO: item.vR_UNITARIO,
                };
              }else if (apiName === 'material-master-import') {
                return {
                  codigo: item.codigo,
                  descripcionproducto: item.descripcionproducto,
                  cantidad: item.cantidad,
                  costounitario: item.costounitario,
                  lt: item.lt,
                  ls: item.ls,
                  origen: item.origen,
                };
              }else if (apiName === 'oc-master-import') {
                return {
                  coD_PRODUCTO: item.coD_PRODUCTO,
                  nombrE_PRODUCTO: item.nombrE_PRODUCTO,
                  nombrE_GRUPO: item.nombrE_GRUPO,
                  cantidad: item.cantidad,
                  vR_UNITARIO: item.vR_UNITARIO,
                  email: item.email || '',
                };
              }else if (apiName === 'ep-master-import') {
                return {
                  coD_PRODUCTO: item.coD_PRODUCTO,
                  nombrE_PRODUCTO: item.nombrE_PRODUCTO,
                  nombrE_GRUPO: item.nombrE_GRUPO,
                  cantidad: item.cantidad,
                  vR_UNITARIO: item.vR_UNITARIO,
                  nombre_proceso: item.nombre_proceso,
                  proceso: item.proceso,
                  linea: item.linea,
                  estado: item.estado,
                };
              }else if (apiName === 'material-master-exclusive-import') {
                console.log('Item recibido para material-master-exclusive-import:', item);
                return {
                  producto: item.producto,
                  exclusivo: item.exclusivo,
                };
              }


              return {};
            });

            if ( apiName === 'material-master-exclusive-import' && rows.length === 0) {
              setMessage('No hay productos exclusivos cargados al momento');
            } else {
              setMessage('');
            }

            setTableData({ columns, rows });

          }catch (error) {
            alert("Error: Alguno de los campos requeridos no está presente en la respuesta de la API.");
            console.error("Detalle del error:", error);
          }
        } else {
          setMessage('La consulta no fue exitosa. Revisa la respuesta del servidor.');
        }
      }
       
      setGlobalLoading(dispatch, false);
    } catch (error) {
      console.error('Error en la petición:', error);
      setMessage(`Error en la importación: ${error.message}`);
    }
  }

  const onSubmit = (data) => {
    dispatch({ type: "LOADING", value: true });

    // setLoading(dispatch, true)
    const formData = new FormData();
    formData.append("file", data.file[0]);
    return importData(formData);

  }

  // const importData = (data) => {
  //   return ImportAPI.import(data, apiName)
  //     .then(response => {
  //       navigate('/product-arrays', { state: response.message });
  //     }).catch(error => {
  //       if (error.response) {
  //         handleAlert(error.response.data.message, 'error')
  //         window.scrollTo(0, 0);
  //       }
  //     }).finally(() => {
  //       setLoading(dispatch, false)
  //     });
  // }

  const importData = (data) => {
  return ImportAPI.import(data, apiName)
    .then(response => {
      setImportId(response.import_id);
      setImportState("pending");
      setPollingImport(true);

      handleAlert(
        "Importación iniciada correctamente. Procesando archivo...",
        "info"
      );
    })
    .catch(error => {
      if (error.response) {
        handleAlert(error.response.data.message, 'error');
        window.scrollTo(0, 0);
      }
    })
    .finally(() => {
      setGlobalLoading(dispatch, false);
    });
  };

  //evento para cerrar y abrir modal de confirmacion
  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const handleClose = (confirmed) => {
    setOpen(false);
    if (confirmed) {
      loadImport();
    }
  };
  const loadImport = async () => {

    if (loading) return;
    setGlobalLoading(dispatch, true);

    const url = `apiresource-${apiName}`; 

    const data = {
      apiName: apiName,
      rows: dataImport,
      fechas: formData
    }; 

    try {
      const response = await ImportAPI.import(data, url);
    
      if (response.status === true) {
        handleAlert(response.message, "success");

        // ✅ limpiar tabla
        setTableData({ columns: [], rows: [] });
        setDataImport([]);

        // ✅ limpiar fechas
        setFormData({});
      } else {
        setMessage('Hubo un problema al cargar los datos.');
      }
    } catch (error) {
      setMessage('Error al hacer la importación.');
    }finally {
      setGlobalLoading(dispatch, false);
    }

  };

  //evento para cerrar y abrir modal de confirmacion

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container justifyContent="center" pb={3} >
        <MDBox sx={{
          width: '80%',
        }}>
          <MDBox mb={4} px={2} >
            <CustomAlert severity={alertColor} message={alertContent} open={alert} onClose={handleAlertClose}></CustomAlert>
          </MDBox>
          <Card>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <Grid item xs={12} sm={12}>
                  <Alert severity="warning">
                    <MDTypography variant="h5">Advertencia</MDTypography>
                    <MDTypography variant="button" color="text" fontWeight="regular">
                      El archivo de excel debe contener en la primera fila los siguientes encabezados
                      de lo contrario no se realizará la importación:
                    </MDTypography>
                    <br></br>
                    <br></br>
                    <MDTypography style={{ whiteSpace: 'pre-wrap' }} variant="button" color="text" fontWeight="regular">
                      <strong>{warning}</strong>
                    </MDTypography>
                  </Alert>
                </Grid>

                <MDBox p={2} lineHeight={0}>
                  <MDTypography variant="h5">{title} con archivo Excel</MDTypography>
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    Seleccione el archivo, este debe ser formato excel o csv
                  </MDTypography>
                </MDBox>
                <MDBox p={2} component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                  <Grid container p={2} spacing={3}>
                    <Grid item xs={6} sm={6}>
                      <MDInput type="file" id="file" {...register("file")}></MDInput>
                      <MDBox>{errors.file && <MDTypography variant="button" color="error">{errors.file?.message}</MDTypography>}</MDBox>
                    </Grid>
                  </Grid>
                  <MDBox sx={{ display: 'flex', justifyContent: 'flex-end' }} p={5}>
                    <ButtonGroup>
                      <MDButton variant="gradient" color="secondary" onClick={() => navigate('/product-arrays')} >
                        Cancelar
                      </MDButton>
                      <MDButton variant="gradient" type="submit" color="info" disabled={isSubmitting}>
                        {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Guardar'}
                      </MDButton>
                    </ButtonGroup>
                  </MDBox>
                </MDBox>
              </Grid>
            </Grid>
          </Card>

          <Card sx={{ marginTop: '20px' }}>
            <MDBox p={2} lineHeight={0}>
              <MDTypography variant="h5">Importación desde Yéminus</MDTypography>
            </MDBox>
            <Grid container spacing={3}>
              {!hideImportButton && (
              <Grid item xs={12} sm={6}>
                <MDBox p={5}>
                  {fields && (
                    <Grid container spacing={2}>
                      {fields.map((field, index) => (
                        <Grid key={index} item xs={12} sm={6}>
                          <DinamicDate 
                            fields={[field]} 
                            formData={formData}
                            handleInputChange={handleInputChange} 
                          />
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </MDBox>
              </Grid>
              )}
              {(
                <Grid item xs={12} sm={3}>
                  <MDBox
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      height: '100%',
                    }}
                    p={5}
                  >
                    <ButtonGroup>
                      <MDButton variant="gradient" color="secondary" onClick={onSubmitImport}>
                        Importar
                      </MDButton>
                    </ButtonGroup>
                  </MDBox>
                </Grid>
              )}
              
              {tableData.rows.length > 0 && (
                <MDBox
                  mt={5}
                  mb={2}
                  ml={8}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <MDButton
                    variant="gradient"
                    color="success"
                    onClick={downloadExcel}
                    sx={{
                      width: 'auto',
                      minWidth: 'unset',
                      px: 3,
                      py: 1.5,
                    }}
                  >
                    Descargar Excel Completo
                  </MDButton>
                </MDBox>
              )}
              
              {/* tabla para registros a importar */}
              <Grid container justifyContent="center" pb={3} >
                <MDBox sx={{ width: '80%', }}>
                  {tableData.columns.length > 0 && (
                    <Card sx={{ marginTop: '20px' }}>
                      <MDBox
                        mx={2}
                        mt={-3}
                        py={3}
                        px={2}
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                      >
                        <MDTypography variant="h6" color="white">
                          Datos de la Importación
                        </MDTypography>
                      </MDBox>
                      <MDBox pt={3} px={2} pb={2}>
                        
                        {/* Mensaje de estado / Alerta arriba de la tabla */}
                        {message && (
                          <div
                            style={{
                              padding: '16px 24px',
                              marginBottom: '20px',
                              textAlign: 'left',
                              backgroundColor: advertencias.length > 0 ? '#fff3cd' : '#f8f9fa',
                              borderLeft: advertencias.length > 0 ? '5px solid #ffc107' : '5px solid #1A73E8',
                              borderRadius: '8px',
                              color: '#344767',
                              fontWeight: 500,
                              whiteSpace: 'pre-line'
                            }}
                          >
                            {message}
                          </div>
                        )}

                        {/* Tabla siempre visible si existen filas */}
                        {tableData?.rows?.length > 0 && (
                          <DataTable
                            table={tableData}
                            isSorted={true}
                            entriesPerPage={true}
                            showTotalEntries={true}
                            noEndBorder
                          />
                        )}

                      </MDBox>
                    </Card>
                  )}
                  {/* tabla para registros a importar */}
                  {tableData.rows.length > 0 && (
                        <MDBox mt={3} display="flex" justifyContent="center">
                          {/* Botón para abrir el diálogo */}
                          <MDButton
                            variant="contained"
                            color="success"
                            onClick={handleClickOpen}
                          >
                            Cargar Datos
                          </MDButton>
                        </MDBox>
                  )}

                  {/* ventana confirmacion */}
                  <Dialog
                    open={open}
                    onClose={() => handleClose(false)}
                  >
                    <DialogTitle>{"Confirmar acción"}</DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          ¿Estás seguro de que deseas cargar los datos?
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => handleClose(false)} color="primary">
                          Cancelar
                        </Button>
                        <Button onClick={() => handleClose(true)} color="primary" autoFocus>
                          Cargar
                        </Button>
                      </DialogActions>
                  </Dialog>

                  <Dialog
                    open={loadingYeminus}
                    disableEscapeKeyDown
                    PaperProps={{
                      sx: {
                        borderRadius: 3,
                        minWidth: 320,
                      },
                    }}
                  >
                    <DialogContent
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 2,
                        py: 4,
                        px: 5,
                      }}
                    >
                      <CircularProgress />

                      <Typography
                        variant="h6"
                        sx={{
                          fontWeight: 600,
                          textAlign: 'center',
                        }}
                      >
                        Conectando con Yéminus
                      </Typography>

                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          textAlign: 'center',
                        }}
                      >
                        Estamos estableciendo conexión con el servicio.
                        Por favor espere...
                      </Typography>
                    </DialogContent>
                  </Dialog>
                </MDBox>
              </Grid>
            </Grid>
          </Card>

        </MDBox >
      </Grid >
      {pollingImport && (
        <Alert severity="info" sx={{ mt: 2 }}>
          Importación en progreso...
          Estado actual: <strong>{importState}</strong>
        </Alert>
      )}
      {/* backdrop preloader */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>  

      <Footer />
    </DashboardLayout >
  );
}